import React from 'react';
import PropTypes from 'prop-types';
import { bem } from 'helpers/class-name';
import Switch from 'components/Switch';

import './EnableClassSwitch.scss';

const { block } = bem('enable-class-switch');

const EnableClassSwitch = ({ disabled, updateIsClassEnabled, venueClass }) => {
  const { classId } = venueClass;

  const switchInputProps = {
    name: `enable-class-${classId}`,
    value: !disabled,
    onBlur: () => {},
    onChange: event => updateIsClassEnabled(venueClass, event.target.checked),
    onDragStart: () => {},
    onDrop: () => {},
    onFocus: () => {},
  };
  const switchMetaProps = {
    active: false,
    asyncValidating: false,
    autofilled: false,
    dirty: false,
    dispatch: () => {},
    form: `enable-switch-class-${classId}`,
    invalid: false,
    pristine: true,
    submitting: false,
    submitFailed: false,
    submitSucceed: false,
    touched: false,
    valid: true,
    visited: false,
  };

  return <Switch className={block()} input={switchInputProps} meta={switchMetaProps} />;
};

EnableClassSwitch.propTypes = {
  venueClass: PropTypes.shape({ classId: PropTypes.number, className: PropTypes.string }),
  disabled: PropTypes.bool,
  updateIsClassEnabled: PropTypes.func,
};

export default EnableClassSwitch;
